// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.green{
  color: #42A948;
}

.inactive-tree {
  color: #3a3a3a;
}

.tree-icon {
  cursor: pointer;
}

.field-view-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
}

.field-view-controls .form-group {
  min-width: 200px;
}

.yield-tooltip {
  white-space: pre-line;
  text-align: left;
  font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/home/field-view/field-view.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".green{\n  color: #42A948;\n}\n\n.inactive-tree {\n  color: #3a3a3a;\n}\n\n.tree-icon {\n  cursor: pointer;\n}\n\n.field-view-controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  justify-content: center;\n}\n\n.field-view-controls .form-group {\n  min-width: 200px;\n}\n\n.yield-tooltip {\n  white-space: pre-line;\n  text-align: left;\n  font-size: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
